// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--RFO+s";
export var cardDeck = "Layout-module--card-deck--7YUIj";
export var contentContainer = "Layout-module--contentContainer--BuC-K";